class Customer.ResponseSchedule extends Backbone.Model
  urlRoot: '/customer/response_schedules'

  defaults: ->
    scheduled_impact_timestamp: moment().unix() * 1000
    ticket_status_after_successful_impact: 'Closed'
    note: ''
    status: 'active'

  validateFields: ->
    @validateDateAndTime()
    @validateLengthOfStrings()

  validateDateAndTime: ->
    # TODO

  validateLengthOfNote: ->
    # TODO

  scheduledImpactTimestamp: ->
    @get('scheduled_impact_timestamp')

  setScheduledImpactTimestamp: (timestamp) ->
    @set('scheduled_impact_timestamp', timestamp)

  setTicketStatusAfterSuccessfulImpact: (ticketStatus) ->
    @set('ticket_status_after_successful_impact', ticketStatus)

  setNote: (note) ->
    @set('note', note)

  suspendByOperator: ->
    @set('status', 'suspended_by_operator')
    @set('last_updater_full_name', "#{Keepcon.current_user.first_name} #{Keepcon.current_user.last_name}")
